import { LifeBuoy, Mail, MessageCircle, FileText, ExternalLink } from "lucide-react";

export default function PanelSupport() {
    return (
        <div data-testid="panel-support" className="p-6 space-y-5 max-w-3xl">
            <div>
                <h1 className="text-xl font-bold flex items-center gap-2"><LifeBuoy className="w-5 h-5" /> Support</h1>
                <p className="text-xs text-slate-500 mt-1">We're here to help — pick the fastest channel.</p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                <Channel icon={Mail} title="Email support" sub="Replies within 2 business hours"
                           href="mailto:support@payouts-portal.app" testid="support-email" />
                <Channel icon={MessageCircle} title="Live chat" sub="Mon–Fri · 10 AM – 7 PM IST"
                           href="#" testid="support-chat" />
                <Channel icon={FileText} title="API docs" sub="Request/response reference"
                           href="/docs" external testid="support-docs" />
                <Channel icon={ExternalLink} title="Status page" sub="System uptime & incidents"
                           href="#" testid="support-status" />
            </div>

            <section className="bg-white border border-slate-200 rounded-xl p-5" data-testid="support-faq">
                <h2 className="font-semibold text-sm">Frequently asked</h2>
                <ul className="mt-3 space-y-3 text-sm">
                    <FAQ q="How long do payouts take to settle?"
                           a="IMPS is instant (seconds). NEFT settles in the next NEFT window (every 30 mins on business days). RTGS is instant on business days only." />
                    <FAQ q="Why am I seeing 'mfa_not_enrolled'?"
                           a="Payouts above ₹10,000 require 2FA. Go to Settings → Two-factor authentication and complete the one-time setup." />
                    <FAQ q="How do I whitelist an IP?"
                           a="Open a support ticket with the IPs or CIDR blocks that should be allowed. Our ops team adds them within 1 business hour." />
                    <FAQ q="What happens if my webhook endpoint is down?"
                           a="We retry with exponential backoff. If your endpoint is still down after retries, you can see the delivery log under API & Webhooks → Webhook Log, and ask us to resend." />
                </ul>
            </section>
        </div>
    );
}

function Channel({ icon: Icon, title, sub, href, external, testid }) {
    return (
        <a href={href} target={external ? "_blank" : undefined} rel={external ? "noreferrer" : undefined} data-testid={testid}
            className="bg-white border border-slate-200 rounded-xl p-4 hover:border-indigo-300 hover:bg-indigo-50 transition flex items-center gap-3">
            <div className="w-10 h-10 rounded-lg bg-indigo-100 flex items-center justify-center text-indigo-700">
                <Icon className="w-5 h-5" />
            </div>
            <div>
                <div className="font-semibold text-sm">{title}</div>
                <div className="text-[11px] text-slate-500">{sub}</div>
            </div>
        </a>
    );
}

function FAQ({ q, a }) {
    return (
        <li>
            <details className="group">
                <summary className="cursor-pointer font-medium text-slate-800 group-open:text-indigo-700">{q}</summary>
                <p className="mt-1.5 text-xs text-slate-600 pl-4">{a}</p>
            </details>
        </li>
    );
}
